import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import {
  FacebookLoginButton,
  GoogleLoginButton,
  TwitterLoginButton,
  AppleLoginButton,
  createSvgIcon,
} from 'react-social-login-buttons';

import CardText from 'components/Card/Text';
import { Row } from 'components/Grid';
import auth from 'lib/auth';
import TwitterIcon from 'components/icons/Twitter';

const SocialButtons = ({ label = 'Sign in' }) => (
  <>
    <CardText>
      <FacebookLoginButton
        onClick={useCallback(
          () => auth.loginSocial('facebook'),
          [],
        )}
      >
        <span>{label} with Facebook</span>
      </FacebookLoginButton>
      <TwitterLoginButton
        icon={createSvgIcon(TwitterIcon)}
        onClick={useCallback(
          () => auth.loginSocial('twitter'),
          [],
        )}
      >
        <span>{label} with X</span>
      </TwitterLoginButton>
      <GoogleLoginButton
        onClick={useCallback(
          () => auth.loginSocial('google'),
          [],
        )}
      >
        <span>{label} with Google</span>
      </GoogleLoginButton>
      <AppleLoginButton
        activeStyle={{ backgroundColor: '#e8e8e8', color: '#010101' }}
        style={{ color: '#000000' }}
        iconColor='#FFFFFF'
        onClick={useCallback(
          () => auth.loginSocial('apple'),
          [],
        )}
      >
        <span>{label} with Apple</span>
      </AppleLoginButton>
    </CardText>
    <CardText>
      <Row centered>
        -OR-
      </Row>
    </CardText>
  </>
);

SocialButtons.propTypes = {
  label: PropTypes.string,
};

export default SocialButtons;
